<template>
  <v-container>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class="font-weight-bold text-capitalize" color="primary">
          <v-icon class="me-1" small>mdi-refresh</v-icon>
        </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Refund Status</span>
          <v-spacer></v-spacer>
          <AuditTrialLog auditType="TAX_UPDATE" />
          <v-btn color="primary" class="light--text" text @click="show_dialog_box = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="mt-2">
            <v-layout>
              <v-flex md4> Check Refund Status </v-flex>
              <v-flex>
                <v-btn color="primary" class="mb-2 mb-sm-4 light--text text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="checkRefundStatus" :loading="btnloading">
                  Check Status
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex md4> Mark as refunded </v-flex>
              <v-flex md4>
                <v-select :items="['OFFLINE']" dense attach solo value="OFFLINE"> </v-select>
              </v-flex>
              <v-flex class="ml-4">
                <v-btn color="error" class="mb-2 mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="markAsRefund" :loading="btnloading">
                  Confirm
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-dialog v-model="showConfirmRefundDialog" max-width="800px">
          <v-card color="pop_bg">
            <v-card-title>
              <span class="text-h6 error--text">Confirm</span>
              <v-spacer></v-spacer>
              <AuditTrialLog auditType="TAX_UPDATE" />
              <v-btn color="primary" class="light--text" text @click="showConfirmRefundDialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container class="mt-2"><span class="text-h6 dark--text">Are you sure want to mark this as Refunded</span> </v-container>
            </v-card-text>

            <v-card-actions class="justify-end mt-n8">
              <v-btn color="error" class="mb-2 mb-sm-4 light--text text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="confirmRefund" :loading="btnConfirmRefund">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="3000" right top color="success">{{ text }}</v-snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  props: {
    refund: {
      required: true,
    },
  },
  methods: {
    markAsRefund() {
      this.showConfirmRefundDialog = true;
    },

    confirmRefund() {
      this.btnloading = true;
      this.btnConfirmRefund = true;
      this.$apollo
        .mutate({
          mutation: require("../api/markAsRefunded.graphql"),
          variables: {
            refund: this.refund._id,
          },
        })
        .then(() => {
          this.show_dialog_box = false;
          this.showConfirmRefundDialog = false;
          this.btnloading = false;
          this.btnConfirmRefund = false;
          this.snackbar = true;
          this.text = "Marked as Refunded";
          this.$root.$emit("getAllOnlineRefund");
        })
        .catch(error => {
          // Error
          this.btnloading = false;
          this.btnConfirmRefund = false;
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
        });
    },
    checkRefundStatus() {
      this.btnloading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/checkRefundStatus.graphql"),
          variables: {
            refund: this.refund._id,
          },
        })
        .refetch({
          refund: this.refund._id,
        })
        .then(data => {
          this.btnloading = false;
          if (data.data.checkRefundStatus) {
            this.snackbar = true;
            this.text = data.data.checkRefundStatus.status;
          }
          this.$root.$emit("getAllOnlineRefund");
        })
        .catch(error => {
          this.btnloading = false;
          console.log(error);
        });
    },
  },
  data: () => ({
    loading: true,
    btnloading: false,
    showConfirmRefundDialog: false,
    show_dialog_box: false,
    btnConfirmRefund: false,
    snackbar: false,
    text: "",
  }),

  created() {},
};
</script>
<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
